import { LeagueGameDayHeaderDetails } from '@/modules/league/new-components/types';
import {
  renderDateMessage,
  renderTimeMessage,
} from '@/utils/actions/leagues/gameDay/functions/getHeaderGameTimeBox';

interface GameTimeBoxProps {
  gameDayInfo: LeagueGameDayHeaderDetails | undefined;
  isFlexLeague: boolean | undefined;
  isTraditionalLeague: boolean | undefined;
  isRsvpPage: boolean;
}

const HeaderGameTimeBox = ({
  gameDayInfo,
  isFlexLeague,
  isTraditionalLeague,
  isRsvpPage,
}: GameTimeBoxProps) => {
  const messageForOpt = renderDateMessage(isFlexLeague, gameDayInfo);
  return (
    <div
      className={`mt-2 w-full flex-col justify-center gap-4 text-gray-900 md:w-full md:flex-row md:gap-6 ${isRsvpPage ? 'flex' : 'hidden'}`}
    >
      {messageForOpt ? (
        <>
          <div className='font-inter leading-20 pt-1 text-sm font-normal md:pt-[2px]'>
            {messageForOpt}
          </div>
          <span className='hidden font-extralight md:inline-block'>|</span>
        </>
      ) : null}
      {!isTraditionalLeague && (
        <div
          className={`font-inter leading-20 text-sm font-normal italic md:pt-[2px] ${!messageForOpt && 'text-center'}`}
        >
          {renderTimeMessage(isFlexLeague, gameDayInfo)}
        </div>
      )}
    </div>
  );
};

export default HeaderGameTimeBox;
